import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Save } from 'lucide-react';
import { API } from '../../config/api';

export const VenuesTitleEditor = ({ headers }) => {
  const [title, setTitle] = useState('');
  useEffect(() => {
    axios.get(`${API}/settings/venues-title`).then(res => setTitle(res.data.title)).catch(console.error);
  }, []);
  const save = async () => {
    try {
      await axios.put(`${API}/settings/venues-title`, { title }, { headers });
      toast.success('Ο τίτλος αποθηκεύτηκε');
    } catch (e) { toast.error('Αποτυχία αποθήκευσης'); }
  };
  return (
    <div className="mb-6 bg-slate-50 rounded-lg p-4" data-testid="admin-venues-title">
      <label className="block text-sm font-medium text-slate-700 mb-1">Τίτλος ενότητας στη σελίδα «Σχετικά»</label>
      <div className="flex gap-2">
        <input value={title} onChange={e => setTitle(e.target.value)} className="flex-1 px-3 py-2 border rounded-lg" placeholder="π.χ. Γήπεδα Σεζόν 2" data-testid="admin-venues-title-input" />
        <button onClick={save} className="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 flex items-center gap-1" data-testid="admin-venues-title-save">
          <Save size={16} /> Αποθήκευση
        </button>
      </div>
    </div>
  );
};
